import {
  UPDATE_ONBOARDING_MAINTENANCE_OPT_OUT,
  RESET_ONBOARDING_MAINTENANCE_OPT_OUT
} from 'state/onboardingMaintenance/OnboardingMaintenanceActions'

export const onboardingMaintenanceOptOutIntialState = {
  missionName: null,
  optOut: false
};

export const onboardingMaintenanceOptOutReducer = (state = {}, action) => {
  const { type } = action;

  if (type === UPDATE_ONBOARDING_MAINTENANCE_OPT_OUT) {
    const { missionName, optOut } = action;
    return {
      missionName,
      optOut
    }
  }

  if(type === RESET_ONBOARDING_MAINTENANCE_OPT_OUT) {
    return onboardingMaintenanceOptOutIntialState;
  }

  return state;
};
